import React from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@material-ui/core/CssBaseline';
import LinearProgress from '@material-ui/core/LinearProgress';
import {createMuiTheme, MuiThemeProvider, withStyles} from '@material-ui/core/styles';

import MUIDataTable from "mui-datatables";

const styles = theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
  },
});

class Archives extends React.Component {

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MUIDataTable: {
                responsiveScroll: {
                    overflowY: "hidden",
                    maxHeight: "none",
                },
            }
        }
    });

    render() {
    return (
      <React.Fragment>
        <CssBaseline />
          {this.props.loading && <LinearProgress />}
        <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={"Les audits archivés"}
              data={this.props.data}
              columns={this.props.columns}
              options={this.props.options}
            />
        </MuiThemeProvider>
      </React.Fragment>
    );
  }
}

Archives.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Archives);



// WEBPACK FOOTER //
// ./src/component/audit/archives.js